import { Component, computed, effect, inject, Signal } from '@angular/core';
import { smoothlyMenu, smoothlyMiniMenu } from '../../../app.helpers';
import { Router, ActivatedRoute } from '@angular/router';
declare let jQuery: any;

import { AuthService } from '../../../auth.service';
import { UserService } from '../../../user.service';

// internacionalization
import { TranslateService, TranslateModule, MissingTranslationHandler } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { OnInit, OnDestroy } from '@angular/core';
import { AppConfiguration } from '../../../conf/app.configuration';
import { BaseComponent } from '../baseComponent/base.component';
import { ContextHelpComponent } from '../help/contextHelp.component';
import { HelpIndexComponent } from '../help/helpIndex.component';
import { ButtonModule } from 'primeng/button';
import { MyMissingTranslationHandler } from '../../missingtemplate.component';
import { ScreenService } from '@/services/screen/screen.service';
import { HelpUseCase } from '@/app/_core/application/help/help.use-cases';

@Component({
  selector: 'topnavbar',
  templateUrl: 'topnavbar.component.html',
  providers: [
    AuthService,
    {
      provide: MissingTranslationHandler,
      useClass: MyMissingTranslationHandler
    }
  ],
  standalone: true,
  imports: [ButtonModule, HelpIndexComponent, ContextHelpComponent, TranslateModule]
})
export class TopnavbarComponent extends BaseComponent implements OnInit, OnDestroy {
  private readonly _deviceDetectorService = inject(ScreenService);
  private readonly _helpUseCases = inject(HelpUseCase);

  public readonly isDesktop: Signal<boolean> = computed(() => this._deviceDetectorService.isDesktopSig());

  viewNotes = false;
  public activeLanguages: Array<string>;
  public activateLangChange = true;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public userService: UserService,
    private appConfig: AppConfiguration
  ) {
    super();
    this.activeLanguages = this.appConfig.getValue('activeLanguages');
    if (!this.activeLanguages) {
      this.activeLanguages = ['es', 'ca', 'gl', 'eu'];
    }
    this._effects();
  }

  private _effects(): void {
    effect(() => {
      if (this._helpUseCases.selectHelpSig().isOpenHelp) {
        smoothlyMiniMenu();

        // toggle: invierte el menú en cada click
        //this.toggleNavigation();
      }
    });
  }

  changeLanguage(lang) {
    this.translate.use(lang);
  }

  changeColor(color) {
    if (color == 'BLUE') {
      jQuery('body').toggleClass('skin1', true);
      jQuery('body').toggleClass('skin2', false);
      jQuery('body').toggleClass('skin3', false);
    } else if (color == 'GREY') {
      jQuery('body').toggleClass('skin1', false);
      jQuery('body').toggleClass('skin2', true);
      jQuery('body').toggleClass('skin3', false);
    } else if (color == 'GREEN') {
      jQuery('body').toggleClass('skin1', false);
      jQuery('body').toggleClass('skin2', false);
      jQuery('body').toggleClass('skin3', true);
    } else {
      jQuery('body').toggleClass('skin1', false);
      jQuery('body').toggleClass('skin2', false);
      jQuery('body').toggleClass('skin3', false);
    }
  }

  isActive(lang): boolean {
    return this.translate.currentLang === lang;
  }

  ngOnInit() {
    // subscribe to router event
    this.subscribe(this.activatedRoute.queryParams, (param: any) => {
      const locale = param['locale'];
      if (locale !== undefined) {
        this.translate.use(locale);
      }
    });
  }

  logout() {
    this.authService.logout();
  }

  toggleNavigation(): void {
    jQuery('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }
  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  prefs() {
    this.router.navigate(['userPrefs']);
  }
}
